import './analisys.css';
import { useEffect, useState } from 'react';

const Analisys = () => {
    const [inputText, setInputText] = useState('');
    const [positiv, setPositiv] = useState(false);
    const [neutPos, setNeutPos] = useState(false);
    const [neutral, setNeutral] = useState(false);
    const [neutNeg, setNeutNeg] = useState(false);
    const [negativ, setNegativ] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [polarity, setPolarity] = useState();

    const startAnalyse = async () => {
        if (!inputText.trim()) {
            alert('Bitte geben Sie einen Text zur Analyse ein.');
            return;
        }

        const wordCount = inputText.trim().split(/\s+/).length;
        if (wordCount < 10) {
            alert('Der Text ist zu kurz. Bitte geben Sie mindestens 10 Wörter ein.');
            return;
        }
        if (wordCount > 500) {
            alert('Hinweis: Das Beta-Tool analysiert bis zu 500 Worte.\nDu willst mehr?\nSchreibe Eva List: kontakt@evalist.de');
            return;
        }

        setIsSubmitting(true);

        try {
            const endpoint = '/api/method_13/';
            
            const getApiBaseUrl = () => {
                return process.env.REACT_APP_API_URL || "http://localhost:8000";
            };

            const response = await fetch(`${getApiBaseUrl()}${endpoint}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ text: inputText }),
            });

            const data = await response.json();
            
            if (response.status === 200) {
                console.log('Response:', data);
                
                // Handle both possible response formats
                let receivedPolarity;
                if (typeof data.average_polarity === 'number') {
                    receivedPolarity = data.average_polarity;
                } else if (typeof data.polarity === 'number') {
                    receivedPolarity = data.polarity;
                } else if (data && typeof data === 'object' && 'result' in data && typeof data.result.polarity === 'number') {
                    receivedPolarity = data.result.polarity;
                } else if (Array.isArray(data) && typeof data[0] === 'number') {
                    receivedPolarity = data[0];
                }
                
                if (receivedPolarity !== undefined) {
                    setPolarity(receivedPolarity);
                } else {
                    alert('Unerwartetes Antwortformat vom Server');
                }
            }
             else if (response.status === 400) {
                alert(data.error || "Hinweis: Das Beta-Tool analysiert bis zu 500 Worte.\nDu willst mehr?\nSchreibe Eva List: kontakt@evalist.de");
            } 
            else if (response.status === 403) {
                // Rate limit exceeded
                alert("Hinweis: Das Beta-Tool führt maximal 14 Scans pro Tag durch. \nDu willst mehr?" + 
                        "\nSchreibe Eva List: kontakt@evalist.de");
            }
            else if (response.status === 500) {
                alert("Interner Serverfehler. Wenden Sie sich an den Administrator.");
            }  
            else {
                // For any other status code, show generic contact admin message
                alert("Bitte kontaktieren Sie den Administrator.");
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Bei der Analyse ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.');
        }
        
        setIsSubmitting(false);
    }

    useEffect(() => {
        const resultat = () => {
            if (polarity === undefined) return;
            
            
            let inputTextRound = Math.round(polarity * 100) / 100;

            switch (true) {
                case inputTextRound >= 0.6 && inputTextRound <= 1:
                    setNegativ(false)
                    setNeutNeg(false)
                    setNeutPos(false)
                    setNeutral(false)
                    setPositiv(true)
                    break;
                case inputTextRound <= 0.59 && inputTextRound >= 0.2:
                    setPositiv(false)
                    setNegativ(false)
                    setNeutNeg(false)
                    setNeutral(false)
                    setNeutPos(true)
                    break;
                case inputTextRound <= 0.19 && inputTextRound >= -0.2:
                    setPositiv(false)
                    setNegativ(false)
                    setNeutNeg(false)
                    setNeutPos(false)
                    setNeutral(true)
                    break;
                case inputTextRound <= -0.21 && inputTextRound >= -0.6:
                    setPositiv(false)
                    setNegativ(false)
                    setNeutPos(false)
                    setNeutral(false)
                    setNeutNeg(true)
                    break;
                case inputTextRound <= -0.61 && inputTextRound >= -1:
                    setPositiv(false)
                    setNeutPos(false)
                    setNeutral(false)
                    setNeutNeg(false)
                    setNegativ(true)
                    break;
                default:
                    break;
            }
        }

        resultat()
    }, [polarity])

    return (
        <div className='analisys'>     
            <div className="art1"></div>   
            <div className="analisysContainer">
                <h4>Teste jetzt deinen Text</h4>
                <p>Füge einen Artikel, Post oder Text ein und finde heraus, wie die Worte wirken. Dies ist eine Open-Beta-Version (max. 500 Worte), die weiterentwickelt wird.</p>
                <div className="analisysHeader">
                    <textarea 
                        type="text" 
                        className="textField" 
                        placeholder="Enter text here" 
                        value={inputText}
                        onChange={e => setInputText(e.target.value)}
                    ></textarea>
                    <button 
                        className={`${isSubmitting ? 'btnAnalisys btnAnalyseAct' : 'btnAnalisys btnAnalyseInact'}`}
                        onClick={startAnalyse}
                        disabled={isSubmitting || !inputText.trim()}
                    >
                        Analyse
                        {isSubmitting && <span className="spinner" />}
                    </button>
                </div>
                <div className="result">
                    <div className="positiv">
                        <div className={`${positiv ? "pos1 active" : " pos1"}`}></div>
                        {positiv && <div className={`${positiv ? "pos2 active" : " pos2"}`}><span className='resultText'>positiv</span></div>}
                    </div>
                    <div className="neutralPos">
                        <div className={`${neutPos ? "neutpos1 active" : "neutpos1"}`}></div>
                        {neutPos && <div className={`${neutPos ? "neutpos2 active" : "neutpos2"}`}><span className='resultText'>neutral+</span></div>}
                    </div>
                    <div className="neutral">
                        <div className={`${neutral ? "neutral1 active" : "neutral1"}`}></div>
                        {neutral && <div className={`${neutral ? "neutral2 active" : "neutral2"}`}><span className='resultText'>neutral</span></div>}
                    </div>
                    <div className="neutralNeg">
                        <div className={`${neutNeg ? "neutNeg1 active" : "neutNeg1"}`}></div>
                        {neutNeg && <div className={`${neutNeg ? "neutNeg2 active" : "neutNeg2"}`}><span className='resultText'>neutral-</span></div>}
                    </div>
                    <div className="negativ">
                        <div className={`${negativ ? "negativ1 active" : "negativ1"}`}></div>
                        {negativ && <div className={`${negativ ? "negativ2 active" : "negativ2"}`}><span className='resultText'>negativ</span></div>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Analisys;